import { render, staticRenderFns } from "./TitleDeedAreaSection.vue?vue&type=template&id=05a0bde2&"
import script from "./TitleDeedAreaSection.vue?vue&type=script&lang=js&"
export * from "./TitleDeedAreaSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports